import React from 'react';
import { Typography, Box } from '@mui/material';

const DynamicFooter = ({ companyName = "Your App Name", showHelpText = true }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Typography
                variant="body2"
                sx={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: '0.9rem'
                }}
            >
                © {currentYear} {companyName}
                {showHelpText && ' • Need help? Contact support'}
            </Typography>
        </Box>
    );
};

export default DynamicFooter;